"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _components = _interopRequireDefault(require("../../styles/components"));

var _PanelStack = _interopRequireDefault(require("../../common/Panel/PanelStack"));

var _Transcript = _interopRequireDefault(require("./Transcript"));

var _Keywords = _interopRequireDefault(require("./Keywords"));

var _Timeline = _interopRequireDefault(require("./Timeline"));

var _Metrics = _interopRequireDefault(require("./Metrics"));

var _Classifiers = _interopRequireDefault(require("./Classifiers"));

var _Controls = _interopRequireDefault(require("./Controls"));

var _MiniPlayer = _interopRequireDefault(require("./MiniPlayer"));

var _dayjs = _interopRequireDefault(require("dayjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint react/forbid-prop-types:0 */
function setParsedCallDate(time) {
  return time ? (0, _dayjs["default"])(time).format("MMM DD, YYYY, hh:mm:ss A") : "";
}

function makeSentimentMapByStartAndEndTime(allSpeakerSentiments) {
  var sentimentMapByStartAndEndTime = {};

  if (!(0, _lodash.isEmpty)(allSpeakerSentiments)) {
    allSpeakerSentiments === null || allSpeakerSentiments === void 0 ? void 0 : allSpeakerSentiments.forEach(function (speakerSentiment) {
      var speakerName = speakerSentiment.speakerName,
          sentimentValues = speakerSentiment.sentimentValues;
      sentimentMapByStartAndEndTime[speakerName] = {};
      sentimentValues === null || sentimentValues === void 0 ? void 0 : sentimentValues.forEach(function (sentiment) {
        sentimentMapByStartAndEndTime[speakerName][sentiment.s + "-" + sentiment.e] = sentiment.v;
      });
    });
  }

  return sentimentMapByStartAndEndTime;
}

var Index = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Index, _React$Component);

  function Index(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "setClickMinMaxPlayerVisible", function () {
      _this.setState({
        isMiniPlayerVisible: !_this.state.isMiniPlayerVisible
      });

      var handleMinimizePlayer = _this.props.handleMinimizePlayer;

      if (handleMinimizePlayer) {
        handleMinimizePlayer(!_this.state.isMiniPlayerVisible);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setSpeakerSentimentValue", function (nextSet, speakerSentimentsMap) {
      if (speakerSentimentsMap === void 0) {
        speakerSentimentsMap = {};
      }

      if (!(0, _lodash.isEmpty)(speakerSentimentsMap)) {
        return speakerSentimentsMap[(0, _lodash.first)(nextSet).s + "-" + (0, _lodash.last)(nextSet).e];
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "computeTurns", (0, _lodash.memoize)(function (words, speakerSentiments) {
      if (words === void 0) {
        words = [];
      }

      if (speakerSentiments === void 0) {
        speakerSentiments = [];
      }

      var turnsSet = [];
      var isMultiChannel = words.some(function (word) {
        return word.m === "turn";
      });
      var remainingWords = [].concat(words);
      var sentimentMapByStartAndEndTime = makeSentimentMapByStartAndEndTime(speakerSentiments);

      while (remainingWords.length) {
        var nextSet = (0, _lodash.takeWhile)(remainingWords, function (word, i) {
          return i === 0 || word.m !== (isMultiChannel ? "turn" : "punc");
        });
        turnsSet.push({
          start: (0, _lodash.first)(nextSet).s,
          end: (0, _lodash.last)(nextSet).e,
          value: _this.setSpeakerSentimentValue(nextSet, sentimentMapByStartAndEndTime[(0, _lodash.first)(nextSet).w]) || 0,
          speaker: isMultiChannel ? (0, _lodash.first)(nextSet).w : null
        });
        remainingWords = (0, _lodash.drop)(remainingWords, nextSet.length);
      }

      return turnsSet;
    }));

    _this.state = {
      marks: [],
      markedRanges: [],
      isMiniPlayerVisible: false,
      playerTopSectionHeight: 0
    };
    _this.markTranscript = _this.markTranscript.bind(_assertThisInitialized(_this));
    _this.setSpeakerSentimentValue = _this.setSpeakerSentimentValue.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Index.prototype;

  _proto.markTranscript = function markTranscript(ranges) {
    this.setState({
      markedRanges: ranges
    });
  } // Sets the height of the transcript grid row to fit to bottom of page rather than extend beyond viewport
  ;

  _proto.updatePlayerTopSectionHeight = function updatePlayerTopSectionHeight() {
    var _document$querySelect, _document$querySelect2, _document$querySelect3, _document$querySelect4, _document$querySelect5, _document$querySelect6;

    // Get the heights for each part of the player that is expected to render
    // in order to get an offset to determine appropriate height
    var controlHeight = ((_document$querySelect = document.querySelector(".control")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.offsetHeight) || 0;
    var progressHeight = ((_document$querySelect2 = document.querySelector(".progress")) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.offsetHeight) || 0;
    var hrLineHeight = ((_document$querySelect3 = document.querySelector(".panel-hr-line")) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.offsetHeight) || 0;
    var transcriptGridRowMarginHeight = document.querySelector(".transcript-grid-row").style.marginTop || 0;
    var panelStackHeaderHeight = ((_document$querySelect4 = document.querySelector(".panel-stack-media-tabs")) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.offsetHeight) + parseInt((_document$querySelect5 = document.querySelector(".panel-stack-media-tabs")) === null || _document$querySelect5 === void 0 ? void 0 : _document$querySelect5.style.marginTop) + parseInt((_document$querySelect6 = document.querySelector(".panel-stack-media-tabs")) === null || _document$querySelect6 === void 0 ? void 0 : _document$querySelect6.style.marginBottom) || 0;
    var standardPlayerHeights = controlHeight + progressHeight + hrLineHeight + panelStackHeaderHeight + parseInt(transcriptGridRowMarginHeight);
    var trackGroup = document.querySelector(".track-group");

    if (trackGroup) {
      // Weird behavior - DOM does not completely render timeline trackGroup so attempt to get
      // the offsetHeight will return 0. Applying a style height will return the expected offsetHeight.
      // Setting height to '1px' will not actually set height to 1px.
      trackGroup.style.height = "1px";

      if (this.state.playerTopSectionHeight !== trackGroup.offsetHeight + standardPlayerHeights) {
        return this.setState({
          playerTopSectionHeight: trackGroup.offsetHeight + standardPlayerHeights
        });
      }
    } else if (this.state.playerTopSectionHeight !== standardPlayerHeights) {
      return this.setState({
        playerTopSectionHeight: standardPlayerHeights
      });
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.updatePlayerTopSectionHeight();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        parsedFromAnalytics = _this$props.parsedFromAnalytics,
        externalHits = _this$props.externalHits,
        isPCIFlagEnabled = _this$props.isPCIFlagEnabled,
        showPCIFlag = _this$props.showPCIFlag,
        handlePCIFlagClick = _this$props.handlePCIFlagClick,
        flagAction = _this$props.flagAction,
        player = _this$props.player,
        hidePlayer = _this$props.hidePlayer,
        transcriptLength = _this$props.transcriptLength;
    var _parsedFromAnalytics$ = parsedFromAnalytics.detectors,
        detectors = _parsedFromAnalytics$ === void 0 ? [] : _parsedFromAnalytics$,
        transcript = parsedFromAnalytics.transcript,
        _parsedFromAnalytics$2 = parsedFromAnalytics.classifiers,
        classifiers = _parsedFromAnalytics$2 === void 0 ? [] : _parsedFromAnalytics$2,
        _parsedFromAnalytics$3 = parsedFromAnalytics.metrics,
        metrics = _parsedFromAnalytics$3 === void 0 ? [] : _parsedFromAnalytics$3,
        groups = parsedFromAnalytics.groups,
        topics = parsedFromAnalytics.topics,
        keyWords = parsedFromAnalytics.keyWords,
        _parsedFromAnalytics$4 = parsedFromAnalytics.categories,
        categories = _parsedFromAnalytics$4 === void 0 ? [] : _parsedFromAnalytics$4,
        mediaId = parsedFromAnalytics.mediaId,
        interactionType = parsedFromAnalytics.interactionType,
        speakerSentiments = parsedFromAnalytics.speakerSentiments,
        metadata = parsedFromAnalytics.metadata,
        verbs = parsedFromAnalytics.verbs,
        entities = parsedFromAnalytics.entities,
        fullTurns = parsedFromAnalytics.fullTurns; // EA-4493 metrics are applicable for chat
    // const enableMetricsAndTimeline = !(
    //   interactionType === "chat" || interactionType === "text"
    // );

    var isChatTextMedia = interactionType === "chat" || interactionType === "text";

    if (metadata.detail) {
      var _metadata$detail, _metadata$detail$call;

      metadata.detail.parsedDate = setParsedCallDate(metadata === null || metadata === void 0 ? void 0 : (_metadata$detail = metadata.detail) === null || _metadata$detail === void 0 ? void 0 : (_metadata$detail$call = _metadata$detail.callDetails) === null || _metadata$detail$call === void 0 ? void 0 : _metadata$detail$call.callStartTime);
    }

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_components["default"].Grid, null, /*#__PURE__*/_react["default"].createElement(_components["default"].GridRow, null, /*#__PURE__*/_react["default"].createElement(_components["default"].GridCell, null, /*#__PURE__*/_react["default"].createElement(_MiniPlayer["default"], {
      isMiniPlayerVisible: this.state.isMiniPlayerVisible,
      setClickMinMaxPlayerVisible: this.setClickMinMaxPlayerVisible,
      metaData: metadata,
      hidePlayer: hidePlayer,
      mediaId: mediaId
    }))), /*#__PURE__*/_react["default"].createElement(_components["default"].GridRow, null, /*#__PURE__*/_react["default"].createElement(_components["default"].GridCell, {
      stretch: true
    }, /*#__PURE__*/_react["default"].createElement(_Controls["default"], {
      mediaId: mediaId,
      speakerSentiments: speakerSentiments,
      isPCIFlagEnabled: isPCIFlagEnabled,
      showPCIFlag: showPCIFlag,
      handlePCIFlagClick: handlePCIFlagClick,
      flagAction: flagAction,
      isMiniPlayerVisible: this.state.isMiniPlayerVisible,
      setClickMinMaxPlayerVisible: this.setClickMinMaxPlayerVisible,
      metaData: metadata,
      isChatTextMedia: isChatTextMedia
    }))), /*#__PURE__*/_react["default"].createElement(_components["default"].GridRow, {
      stretch: true,
      style: {
        display: "inline-flex",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/_react["default"].createElement(_components["default"].GridCell, {
      stretch: true,
      style: {
        flexDirection: "column",
        width: "100%"
      }
    }, /*#__PURE__*/_react["default"].createElement(_components["default"].GridRow, {
      style: {
        width: "100%",
        minHeight: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement(_components["default"].GridCell, {
      stretch: true
    }, /*#__PURE__*/_react["default"].createElement(_Timeline["default"], {
      transcriptLength: transcriptLength,
      metaData: metadata,
      isChatTextMedia: isChatTextMedia,
      detectors: detectors,
      turns: this.computeTurns(transcript, speakerSentiments),
      mediaId: mediaId,
      updatePlayerTopSectionHeight: function updatePlayerTopSectionHeight() {
        return _this2.updatePlayerTopSectionHeight();
      }
    }))), /*#__PURE__*/_react["default"].createElement("hr", {
      className: "panel-hr-line"
    }), /*#__PURE__*/_react["default"].createElement(_components["default"].GridRow, {
      style: {
        width: "100%",
        overflow: "hidden"
      },
      className: "transcript-grid-row"
    }, /*#__PURE__*/_react["default"].createElement(_components["default"].GridCell, {
      stretch: true,
      style: {
        height: "100%"
      }
    }, /*#__PURE__*/_react["default"].createElement(_PanelStack["default"], null, /*#__PURE__*/_react["default"].createElement(_Transcript["default"], {
      fullTurns: fullTurns,
      title: "Transcript",
      transcript: transcript,
      markedRanges: this.state.markedRanges,
      isChatTextMedia: isChatTextMedia,
      metadata: metadata,
      isPlayer: false
    }), metrics.length ? /*#__PURE__*/_react["default"].createElement(_Metrics["default"], {
      title: "Metrics",
      metrics: metrics,
      isPlayer: false,
      isChatTextMedia: isChatTextMedia
    }) : null, classifiers.length ? /*#__PURE__*/_react["default"].createElement(_Classifiers["default"], {
      title: "Classifiers",
      classifiers: classifiers,
      isPlayer: false
    }) : null)), !!categories.length || !!entities.length || !!groups.length || !!keyWords.length || !!topics.length || !!verbs.length || externalHits && externalHits.hits && !!externalHits.hits.length ? /*#__PURE__*/_react["default"].createElement(_components["default"].GridCell, {
      style: {
        width: "25%",
        minWidth: "200px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Keywords["default"], {
      categories: categories,
      entities: entities,
      externalHits: externalHits,
      groups: groups,
      keyWords: keyWords,
      topics: topics,
      verbs: verbs,
      markTranscript: this.markTranscript
    })) : null)))));
  };

  return Index;
}(_react["default"].Component);

var _default = Index;
exports["default"] = _default;